/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

/** Emails that appear on more than one contact (normalized lower-case). */
export const collectDuplicateContactEmails = (
    contacts: Array<{ email?: string | null } | null | undefined> | null | undefined
): Set<string> => {
    const emailCounts = new Map<string, number>()

    for (const contact of contacts ?? []) {
        const email = (contact?.email || '').trim().toLowerCase()
        if (!email) {
            continue
        }
        emailCounts.set(email, (emailCounts.get(email) || 0) + 1)
    }

    return new Set(
        Array.from(emailCounts.entries())
            .filter(([, count]) => count > 1)
            .map(([email]) => email)
    )
}
